import React, { useState } from 'react';
import { toast } from 'sonner';
import { Loader2, MessageSquareWarning, Settings2 } from 'lucide-react';
import { api } from '../../../lib/api';
import { mensajeDe } from '../responder/utilidades';
import BandejaCasos from './BandejaCasos';
import './buzon.css';

/*
 * Pestaña «Casos» del editor de Orvian Forms. Con el buzón activo, su bandeja; si no, qué es y el
 * botón para activarlo (solo quien edita llega aquí sin buzón: ver FormEditor → verCasos).
 */

export default function PestanaCasos({ formId, formulario, puedeEditar, onConfigurar, onActivado }) {
  const [activando, setActivando] = useState(false);
  const activo = !!formulario?.buzon?.activo;

  const activar = async () => {
    setActivando(true);
    try {
      const { data } = await api.put(`/forms/${formId}/buzon`, { activo: true });
      onActivado?.(data.buzon);
      toast.success(data.casos_creados ? `Buzón activado · ${data.casos_creados} respuestas pasaron a ser casos` : 'Buzón activado');
    } catch (err) {
      toast.error(mensajeDe(err, 'No se pudo activar el buzón'));
    } finally {
      setActivando(false);
    }
  };

  if (activo) {
    return (
      <div className="bz-en-editor">
        <BandejaCasos formId={formId} onConfigurar={puedeEditar ? onConfigurar : null} />
      </div>
    );
  }
  return (
    <div className="bz-activar">
      <MessageSquareWarning className="h-9 w-9" style={{ color: 'var(--accent)' }} aria-hidden="true" />
      <h2>Gestiona las respuestas como casos</h2>
      <p className="bz-texto-2">
        Ideal para un buzón de quejas y sugerencias, solicitudes o reportes: cada respuesta se convierte en un caso que
        alguien atiende hasta cerrarlo.
      </p>
      <ul>
        <li>Folio para quien lo envía y una página para seguir su caso y contestar.</li>
        <li>Asignación manual, por categoría o por turnos; reasignar con motivo.</li>
        <li>Estados, prioridad, plazos con aviso al vencer, etiquetas y notas internas.</li>
        <li>Aurora IA clasifica, resume y redacta la respuesta.</li>
        <li>Lista, tablero y estadísticas del equipo.</li>
      </ul>
      {puedeEditar && (
        <div className="flex flex-wrap gap-2">
          <button type="button" className="bz-boton-principal" onClick={activar} disabled={activando}>
            {activando && <Loader2 className="h-4 w-4 od-spin" />} Activar el buzón
          </button>
          <button type="button" className="bz-boton-borde" onClick={onConfigurar}><Settings2 className="h-4 w-4" /> Configurar antes de activar</button>
        </div>
      )}
    </div>
  );
}
